import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import Util from '../../../util'

const state = {
  token: localStorage.getItem('token'),
  user: Util.getUser(),
  client: localStorage.getItem('client')?JSON.parse(localStorage.getItem("client")):null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js